const breakpoints = {
  xxs: 480,
  xs: 600,
  smTablet: 720,
  sm: 840,
  md: 960,
  lgTablet: 1024,
  lg: 1280,
  xl: 1440,
  xxl: 1600,
  xxxl: 1920,
}

export const MOBILE_VIEWPORT = `(max-width:${breakpoints.xs}px)` // media query for useMediaQuery()
export const MOBILE = `@media ${MOBILE_VIEWPORT}` // media rule for styled components

export const TABLET_VIEWPORT = `(max-width:${breakpoints.lgTablet}px)`
export const TABLET = `@media ${TABLET_VIEWPORT}`

export default breakpoints
